import(/* webpackMode: "eager", webpackExports: ["AcademySearchProvider"] */ "/vercel/path0/apps/web/src/app/(cms)/academy/components/academy-search-provider.tsx");
